import { render, staticRenderFns } from "./NotificationMenuItem.vue?vue&type=template&id=c7152c58&scoped=true"
import script from "./NotificationMenuItem.vue?vue&type=script&lang=js"
export * from "./NotificationMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7152c58",
  null
  
)

export default component.exports